import TableSelectionInput from "../../components/inputs/selections/table.selection.input";
import TableTextInput from "../../components/inputs/texts/table.text.input";
import TableDatePickerInput from "../../components/inputs/dates/table.datePicker.input";
import TableNumberInput from "../../components/inputs/numbers/table.number.input";
import TableMultiSelectInput from "../../components/inputs/selections/multi/table.multi.select.input";
import TableDateTimePickerInput from "../../components/inputs/dates/table.dateTimePicker.input";
import TextLink from "../../components/links/text.link.component";
import TableSearchSelection from "../../components/inputs/selections/tableSearch.selection.input";
import CustomerSearchSelection from "../../components/inputs/selections/search/customer.search.selection.input";
import PrintLink from "../../components/links/print.link.component";

const useReturnTableComponents = () => {
  const getTableComponent = (field, key) => {
    switch (field.type) {
      case "text":
        return <TableTextInput key={key} {...field.props} />;
      case "selection":
        return <TableSelectionInput key={key} {...field.props} />;
      case "customerSearchSelection":
        return <CustomerSearchSelection key={key} {...field.props} />;
      case "date":
        return <TableDatePickerInput key={key} {...field.props} />;
      case "datetime":
        return <TableDateTimePickerInput key={key} {...field.props} />;
      case "number":
        return <TableNumberInput key={key} {...field.props} />;
      case "multiSelect":
        return <TableMultiSelectInput key={key} {...field.props} />;
      case "link":
        return <TextLink key={key} {...field.props} />;
      case "print":
        return <PrintLink key={key} {...field.props} />;
      default:
        console.log(`Error: Invalid field type: ${field?.type}`);
        return null;
    }
  };

  const getTableComponents = ({ fields = [] }) => {
    return fields.map((field, index) =>
      getTableComponent(field, field.id || index)
    );
  };

  return { getTableComponents };
};

export default useReturnTableComponents;
